import { render, staticRenderFns } from "./DeleteReportCustomComponentFooter.vue?vue&type=template&id=8bc7f608"
import script from "./DeleteReportCustomComponentFooter.vue?vue&type=script&lang=js"
export * from "./DeleteReportCustomComponentFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports